import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Breadcrumbs.scss';

const Breadcrumb: React.FC = () => {
  const location = useLocation();

  const pathnames = location.pathname
    .split('/')
    .filter((x) => x);

  return (
    <nav className="breadcrumb">
      <Link to="/" className="breadcrumb-link breadcrumb-home">Home</Link>

      {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
        const formattedName = decodeURIComponent(name)
          .replace(/-/g, ' ')
          .replace(/\b\w/g, (char) => char.toUpperCase());

        return (
          <span key={name} className="breadcrumb-segment">
            <span className="breadcrumb-separator">{'>'}</span>
            {index === pathnames.length - 1 ? (
              <span className="breadcrumb-current">{formattedName}</span>
            ) : (
              <Link to={routeTo} className="breadcrumb-link">
                {formattedName}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
